import { defineMessages } from 'react-intl';

export default defineMessages({
  emailPlaceholder: {
    id: 'global_trovitAds_email',
    defaultMessage: 'Email',
  },
  receiveOffers: {
    id: 'global_alert_recive_offer',
    defaultMessage: 'Receive offers',
  },
  errorMailEmpty: {
    id: 'global_error_mail_empty',
    defaultMessage: 'Please enter your email address',
  },
  errorTermsConditions: {
    id: 'global_erroragreement',
    defaultMessage: 'Please accept the terms and conditions.',
  },
  emailClaimTitle: {
    id: 'global_wpn_mobile_email_claim_title',
    defaultMessage: 'Stay up-to-date on your email',
  },
  emailClaimDescription: {
    id: 'global_wpn_mobile_email_claim_desc',
    defaultMessage:
      'Get updates for your search on your favorite email account with Trovit email alerts.',
  },
  emailClaimCTA: {
    id: 'global_wpn_mobile_email_claim_cta',
    defaultMessage: 'Get updates',
  },
  emailUserAlreadyExists: {
    id: 'global_trovitAds_userExists',
    defaultMessage: 'A user with this email address already exists.',
  },
  emailError: {
    id: 'global_trovitAds_backoffice_applies_updateError',
    defaultMessage: 'An error has occurred.',
  },
  termsagreementExplicitTwo: {
    id: 'global_termsagreement_explicit_2',
    defaultMessage:
      'By creating this email alert, you agree to our <a href="{%s}" target="_blank" rel="nofollow, noopener">Terms</a> and our <a href="{%s1}" target="_blank" rel="nofollow, noopener">Privacy Policy</a>. You can unsubscribe at any time.',
  },
});



// WEBPACK FOOTER //
// ./app/Alerts/permissionsEmailBanner/components/BannerForm/messages.js